import React, { Component } from 'react';
import { connect } from "react-redux";
import {
    removeAccountFavorite,
    removeProductGroupFavorite,
    removeOpportunityFavorite
} from "../../../actions/userActions";
import { formatOpportunityCloseDate } from '../../../utils/date';
import stringUtils from "../../../utils/string";

require('./ModalListItem.scss');

@connect((store) => ({
    user: store.user,
    userFavoritesAccounts: store.favorites.accounts,
    userFavoritesProductGroups: store.favorites.productGroups,
    userFavoritesOpportunities: store.favorites.opportunities
}))

class FavoriteItem extends Component {

    removeAccountFavorite(account) {
        this.props.dispatch(removeAccountFavorite(account));
    }

    removeProductGroupFavorite(productGroup) {
        this.props.dispatch(removeProductGroupFavorite(productGroup));
    }

    removeOpportunityFavorite(opp) {
        this.props.dispatch(removeOpportunityFavorite(opp));
    }

    render() {
        const { type } = this.props;
        switch (type) {
            case 'account':
                return (
                    <div className="row favItem">
                        <div className="col-sm-8 col-xs-12">
                            <p className="itemId">Account ID: #{ this.props.content.accountId }</p>
                            <h5 className="accountName">{ this.props.content.accountName }</h5>
                            <p className="standardCompanyName">{ this.props.content.company.standardCompanyName }</p>
                            <p className="locationNumber"><em>{ this.props.content.locations.length } Locations</em></p>
                        </div>

                        <div className="col-sm-4 col-xs-12 itemButton">
                            <button className={ this.props.buttonStyle }
                                    onClick={ () => this.removeAccountFavorite(this.props.content)}>
                                Delete Favorite</button>
                        </div>

                    </div>
                );
            case 'productGroup':
                return (
                    <div className="row favItem">
                        <div className="col-sm-8 col-xs-12">
                            <h5 className="accountName">{ this.props.content.productGroupDescr }</h5>
                            <p className="standardCompanyName">{ this.props.content.productLineDescr }</p>
                        </div>

                        <div className="col-sm-4 col-xs-12 itemButton">
                            <button className={ this.props.buttonStyle }
                                    onClick={ () => this.removeProductGroupFavorite(this.props.content)}>
                                Delete Favorite</button>
                        </div>

                    </div>
                );
            case 'opportunity':
                return (
                    <div className="row favItem">
                        <div className="col-sm-8 col-xs-12">
                            <h5 className="accountName">{ this.props.content.opportunityId } - { this.props.content.opportunityName }</h5>
                            <div className="location">Amount: { stringUtils.formatAmount(this.props.content.opportunityUsdAmount) } USD</div>
                            <div className="location">Account Manager: { this.props.content.primaryAccountManager }</div>
                            <div className="location">Stage: { this.props.content.opportunityStage }</div>
                            <div className="location">Deal Type: { this.props.content.dealType }</div>
                            <div className="location">Close Date: { formatOpportunityCloseDate(this.props.content.closeDate) }</div>
                        </div>

                        <div className="col-sm-4 col-xs-12 itemButton">
                            <button className={ this.props.buttonStyle }
                                    onClick={ () => this.removeOpportunityFavorite(this.props.content)}>
                                Delete Favorite</button>
                        </div>

                    </div>
                )
        }
    }
}

export default FavoriteItem;



// WEBPACK FOOTER //
// ./app/components/Modals/ModalListItems/FavoriteItem.jsx